export const NEW_OPTIONS = {
  PREDEFINED_STATIC: 'Static',
  PREDEFINED_ENROLLMENTDATE: 'Target Enrollment Date',
  CUSTOMIZED_AGEBASED: 'Create Customized Age-Based',
  CUSTOMIZED_STATIC: 'Create Customized Static',
};